// frontend/admin-portal/src/components/settings/items/ToggleSwitch.jsx
import React from "react";

export default function ToggleSwitch({
  checked,
  onChange,
  label,
  disabled = false,
}) {
  const handle = (e) => {
    if (typeof onChange === "function") onChange(e.target.checked);
  };
  return (
    <label className="fh-toggle">
      <input
        type="checkbox"
        checked={!!checked}
        onChange={handle}
        disabled={disabled}
      />
      <span className="fh-toggle__track">
        <span className="fh-toggle__thumb" />
      </span>
      {label && <span className="fh-toggle__label">{label}</span>}
    </label>
  );
}
